@if (showSpinner) {
  <cap-spinner-small></cap-spinner-small>
}
@if (_hasRight) {
  <span>
    @if (grundstueckEntry) {
      <cap-amtliche-vermessung
        [art]="grundstueckEntry?.grundstueckArt"
        [flaechenMaessigNichtAusgeschieden]="grundstueckEntry?.flaechenMaessigNichtAusgeschieden"
        [grundstueckId]="gsId"
        [hasRight]="_hasRight">
      </cap-amtliche-vermessung>
    }
    @if (grundstueckEntry) {
      <cap-grundbuch [art]="grundstueckEntry?.grundstueckArt" [grundstueckId]="gsId" [hasRight]="_hasRight"> </cap-grundbuch>
    }
    @if (grundstueckEntry && parameterAmtlicheBewertung) {
      <cap-amtliche-bewertung [art]="grundstueckEntry?.grundstueckArt" [grundstueckId]="gsId" [hasRight]="_hasRight">
      </cap-amtliche-bewertung>
    }
  </span>
}
@if (!_hasRight) {
  <div class="mb-2">
    <span>{{ "gemaessGrundbuch" | translate }}</span>
  </div>
}
